export interface WorkloadLike {
  workload_value?: string | number | null
  status?: string | number | null
  is_active?: boolean | null
  active?: boolean | null
}

const INACTIVE_STATUSES = new Set([
  'inactive',
  'inactived',
  'disabled',
  'removed',
  'deleted',
])

export function isActiveWorkload(workload: WorkloadLike): boolean {
  if (workload.is_active === false || workload.active === false) {
    return false
  }

  if (workload.status == null || workload.status === '') {
    return true
  }

  if (typeof workload.status === 'number') {
    return workload.status === 1
  }

  return !INACTIVE_STATUSES.has(String(workload.status).toLowerCase())
}

export function getActiveWorkloads<T extends WorkloadLike>(
  workloads: T[] | null | undefined
): T[] {
  if (!workloads?.length) {
    return []
  }

  return workloads.filter(workload => {
    if (!isActiveWorkload(workload)) {
      return false
    }

    const value = workload.workload_value
    return value != null && String(value).trim() !== ''
  })
}

export function collectUniqueActiveWorkloadValues(
  products: { workloads?: WorkloadLike[] | null }[] | null | undefined
): string[] {
  const unique = new Set<string>()

  for (const product of products ?? []) {
    for (const workload of getActiveWorkloads(product.workloads)) {
      unique.add(String(workload.workload_value))
    }
  }

  return [...unique].sort((left, right) => Number(right) - Number(left))
}

export function collectUniqueActiveWorkloadValuesFromList(
  workloads: WorkloadLike[] | null | undefined
): string[] {
  const unique = new Set<string>()

  for (const workload of getActiveWorkloads(workloads)) {
    unique.add(String(workload.workload_value))
  }

  return [...unique].sort((left, right) => Number(right) - Number(left))
}

export function formatCourseWorkloadLabel(
  workloads: WorkloadLike[] | null | undefined
): string | null {
  const values = getActiveWorkloads(workloads)
    .map(workload => Number(workload.workload_value))
    .filter(value => Number.isFinite(value))
    .sort((left, right) => left - right)

  const first = values.at(0)
  const last = values.at(-1)

  if (first == null || last == null) {
    return null
  }

  if (values.length === 1 || first === last) {
    return `${first} Horas`
  }

  return `${first} à ${last} Horas`
}
